<template>
  <v-row class="px-8 py-8">
    <v-col md="12" class="text-center">
      <h1>Details</h1>
      <v-divider width="120px" class="mx-auto" color="#ff865a"></v-divider>
    </v-col>
    <v-col cols="12" sm="12" md="6" lg="6">
      <v-card elevation="24" max-width="904" min-height="400" class="mx-auto">
        <v-system-bar lights-out></v-system-bar>
        <v-carousel
          :continuous="false"
          :cycle="cycle"
          :show-arrows="false"
          hide-delimiter-background
          delimiter-icon="mdi-minus"
          height="300"
        >
          <v-carousel-item v-for="(slide, i) in slides" :key="i">
            <v-sheet :color="colors[i]" height="100%" tile>
              <v-row class="fill-height" align="center" justify="center">
                <div class="display-3">{{ slide }} Slide</div>
              </v-row>
            </v-sheet>
          </v-carousel-item>
        </v-carousel>
        <v-list two-line>
          <v-list-item>
            <v-list-item-avatar>
              <v-img src="https://cdn.vuetifyjs.com/images/john.png"></v-img>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="title">John Leider</v-list-item-title>
              <v-list-item-subtitle class="subtitle-1">Author</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-col>
    <v-col cols="12" sm="12" md="6" lg="6">
      <v-card
        ref="form"
        elevation="24"
        max-width="904"
        min-height="400"
        class="mx-auto"
      >
        <v-card-text>
          <v-card class="mx-auto mt-10" max-width="400" min-height="310" tile>
            <v-list dense>
              <v-list-item-title  class="title mb-4" color="primary">Post Report</v-list-item-title >
              <v-list-item-group v-model="item" color="primary">
                <v-list-item v-for="(item, i) in items" :key="i">
                  <v-list-item-icon>
                    <v-icon v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content style="display: contents;">
                    <v-list-item-title v-text="item.text"></v-list-item-title>
                    <v-list-item-title v-text="item.name"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card>
        </v-card-text>
        <v-divider class="mt-8"></v-divider>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      colors: [
        "primary",
        "secondary",
        "yellow darken-4",
        "red lighten-2",
        "orange darken-1"
      ],
      cycle: false,
      slides: ["First", "Second", "Third", "Fourth", "Fifth"],
      item: 1,
      items: [
        //  { text: 'Influencer', icon: 'mdi-account' },
        { text: "Real-Time", icon: "far fa-clock", name: "impressions" },
        { text: "Post", icon: "far fa-clone", name: "reach" },
        { text: "Reach", icon: "far fa-thumbs-up", name: "reach" },
        { text: "Comments", icon: "far fa-comment", name: "reach" },
        { text: "Views", icon: "far fa-eye",name: "reach" },
        { text: "Engagement rate", icon: "far fa-eye",name: "reach" }
      ],

      insightData: {
        data: [
          {
            name: "impressions",
            period: "lifetime",
            values: [{ value: 517 }],
            title: "Impress\u00f5es",
            description:
              "N\u00famero total de vezes que o objeto de m\u00eddia foi visto",
            id: "17941101007220106/insights/impressions/lifetime"
          },
          {
            name: "reach",
            period: "lifetime",
            values: [{ value: 431 }],
            title: "Alcance",
            description:
              "N\u00famero total de contas \u00fanicas que viram o objeto de m\u00eddia",
            id: "17941101007220106/insights/reach/lifetime"
          },
          {
            name: "engagement",
            period: "lifetime",
            values: [{ value: 79 }],
            title: "Envolvimento",
            description:
              "N\u00famero total de curtidas e coment\u00e1rios no objeto de m\u00eddia",
            id: "17941101007220106/insights/engagement/lifetime"
          }
        ]
      }
    };
  }
};
</script>
